"use strict";

function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Ribbon = exports.Fold = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}
function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--1qt20u4"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    ", ";\n    top: ", ";\n    width: 100%;\n"], ["\n    position: absolute;\n    ", ";\n    top: ", ";\n    width: 100%;\n"])), function (_a) {
  var side = _a.side;
  return "".concat(side, ": 0");
}, function (_a) {
  var top = _a.top;
  return typeof top === "number" ? "".concat(top, "px") : top;
});
exports.Wrapper = Wrapper;
var Ribbon = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Ribbon",
  componentId: "fluffy--14wb0qm"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    ", ";\n    background: ", ";\n    color: ", ";\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);\n    border-radius: ", ";\n\n    ", "\n"], ["\n    position: absolute;\n    ", ";\n    background: ", ";\n    color: ", ";\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);\n    border-radius: ", ";\n\n    ", "\n"
// rotate 360° optimizes the antialiasing
])), function (_a) {
  var side = _a.side;
  return "".concat(side, ": 0");
}, function (_a) {
  var background = _a.background;
  return background;
}, function (_a) {
  var color = _a.color;
  return color;
}, function (_a) {
  var theme = _a.theme;
  return "".concat(theme.space[3], "px ").concat(theme.space[8], "px");
}, function (_a) {
  var theme = _a.theme;
  return "".concat(theme.fontSizes[2], "px");
}, function (_a) {
  var theme = _a.theme;
  return "".concat(theme.lineHeights[2]);
}, function (_a) {
  var theme = _a.theme;
  return theme.fonts.generic[1];
}, function (_a) {
  var side = _a.side,
    theme = _a.theme;
  return side === "left" ? "0 ".concat(theme.space[1], "px ").concat(theme.space[1], "px 0") : "".concat(theme.space[1], "px 0 0 ").concat(theme.space[1], "px");
}, function (_a) {
  var fold = _a.fold,
    side = _a.side,
    theme = _a.theme;
  return !fold ? "" : (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        margin-", ": -", "px;\n        padding-", ": ", "px;\n    "], ["\n        margin-", ": -", "px;\n        padding-", ": ", "px;\n    "])), side, theme.space[4], side, theme.space[7] + theme.space[4]);
});
// rotate 360° optimizes the antialiasing
exports.Ribbon = Ribbon;
var Fold = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Fold",
  componentId: "fluffy--yc5h97"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    transform: rotate(360deg);\n    ", ";\n    ", ";\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: ", ";\n    border-color: ", ";\n"], ["\n    position: absolute;\n    transform: rotate(360deg);\n    ", ";\n    ", ";\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: ", ";\n    border-color: ", ";\n"])), function (_a) {
  var side = _a.side;
  return "".concat(side, ": 0");
}, function (_a) {
  var fold = _a.fold,
    theme = _a.theme;
  return "".concat(fold === "up" ? "top" : "bottom", ": -").concat(theme.space[3], "px");
}, function (_a) {
  var fold = _a.fold,
    side = _a.side,
    theme = _a.theme;
  return [side === "right" ? "".concat(theme.space[3], "px") : "0", fold === "down" ? "".concat(theme.space[4], "px") : "0", side === "left" ? "".concat(theme.space[3], "px") : "0", fold === "up" ? "".concat(theme.space[4], "px") : "0"].join(" ");
}, function (_a) {
  var background = _a.background,
    fold = _a.fold,
    foldColor = _a.foldColor,
    side = _a.side;
  var combinedFoldColor = foldColor || (0, _polished.darken)(0.2, background);
  return [fold === "down" && side === "right" ? combinedFoldColor : "transparent", fold === "down" && side === "left" ? combinedFoldColor : "transparent", fold === "up" && side === "left" ? combinedFoldColor : "transparent", fold === "up" && side === "right" ? combinedFoldColor : "transparent"].join(" ");
});
exports.Fold = Fold;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;